import React, { useState, useEffect } from "react";
import {
  Modal,
  Paper,
  Typography,
  TextField,
  IconButton,
  Grid,
  CardContent,
  CardMedia,
} from "@mui/material";
import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import { LoadingButton } from "@mui/lab";
import { toastAlert } from "../../../utils/AlertContext";
import { getUpdateIndicatorURL } from "../../../utils/ConstantsURL";

export const EditIndicator = ({
  token,
  open,
  close,
  indicator,
  selectedDate,
  selectedIdSection,
  sections,
  refresh,
}) => {
    const [indicatorData, setIndicatorData] = useState({
    id: "",
    title: "",
    fecha: "",
    id_section: "",
    imagen: null,
  });
  const [newImage, setNewImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const validate = () => {
    return (
      !indicatorData.fecha ||
      !indicatorData.id_section ||
      !indicatorData.imagen
    );
  };

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("titulo", indicatorData.title);
      formData.append("fecha", indicatorData.fecha);
      formData.append("seccion_id", indicatorData.id_section);

      if (newImage) {
        formData.append("image", newImage);
      }

      const response = await fetch(getUpdateIndicatorURL(indicatorData.id), {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        toastAlert("Error al enviar la petición", "error");
        setLoading(false);
        return;
      }
      toastAlert("Indicador editado correctamente", "success");
      setLoading(false);
      close();
      refresh();
    } catch (error) {
      toastAlert("Error al enviar la petición: " + error, "error");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (indicator) {
      setIndicatorData(indicator);
      setIndicatorData({
        ...indicator,
        fecha: selectedDate,
        id_section: selectedIdSection
      });
    }
  }, [indicator, selectedDate, selectedIdSection]);

  const handleChange = (field) => (event) => {
    setIndicatorData({ ...indicatorData, [field]: event.target.value });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNewImage(file);
      const imageUrl = URL.createObjectURL(file);
      setIndicatorData((prevData) => ({ ...prevData, imagen: imageUrl }));
    }
  };

  const handleImageClick = () => {
    document.getElementById("imageInput").click();
  };

  if (!indicator) return null;

  return (
    <Modal open={open} onClose={close}>
      <Paper
        elevation={2}
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          width: "70%",
          height: "70%",
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Typography variant="h6">Editar Indicador</Typography>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>

        <div style={{ flex: 1, overflowY: "auto" }}>
          <Grid container spacing={5} style={{ padding: "15px" }}>
            <Grid item xs={12} md={4}>
              <CardMedia
                component="img"
                style={{ width: "100%", height: "auto", borderRadius: "25px" }}
                image={indicatorData.imagen || "/WB.png"}
                alt={indicatorData.title}
                onClick={handleImageClick}
              />
              <input
                type="file"
                id="imageInput"
                style={{ display: "none" }}
                accept="image/*"
                onChange={handleImageChange}
              />

              <Typography
                variant="body1"
                color="textSecondary"
                component="div"
                style={{
                  marginTop: "10px",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "14px",
                }}
              >
                <InfoIcon style={{ marginRight: "5px", fontSize: "20px" }} />{" "}
                Presiona la imagen para cambiarla
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <CardContent style={{ padding: "0" }}>
                <div style={{ marginBottom: "10px" }}>
                  <Typography
                    variant="h6"
                    color="textSecondary"
                    component="div"
                  >
                    Título del indicador:
                  </Typography>
                  <TextField
                    variant="outlined"
                    fullWidth
                    value={indicatorData.title}
                    onChange={handleChange("title")}
                    margin="dense"
                  />
                </div>
                <div style={{ marginBottom: "10px", display: "flex" }}>
                  <TextField
                    label="Fecha"
                    variant="outlined"
                    fullWidth
                    type="date"
                    value={indicatorData.fecha}
                    onChange={handleChange("fecha")}
                    margin="dense"
                    InputLabelProps={{ shrink: true }}
                  />
                  <FormControl sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="select-autowidth-label">Sección</InputLabel>
                    <Select
                      labelId="select-autowidth-label"
                      id="select-autowidth"
                      value={indicatorData.id_section}
                      onChange={handleChange("id_section")}
                      autoWidth
                      label="Seccion"
                    >
                      {sections.map((item) => (
                        <MenuItem key={item.ID_SECCION} value={item.ID_SECCION}>
                          {item.NOMBRE_SECCION}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </CardContent>
            </Grid>
          </Grid>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <LoadingButton
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            loading={loading}
            disabled={validate()}
          >
            Confirmar
          </LoadingButton>
        </div>
      </Paper>
    </Modal>
  );
};
